import React, { useState } from "react";
import { Phone, MapPin, Clock, Mail, Send } from "lucide-react";
import { restaurantInfo } from "../data/mock";
import Reveal from "../components/Reveal";
import { useI18n } from "../data/i18n";

const DiamondDivider = () => (
  <div className="flex items-center justify-center gap-2 my-4">
    <div className="w-12 h-px bg-gradient-to-r from-transparent to-[#e4c590]"></div>
    <span className="diamond-mark"></span>
    <span className="diamond-mark opacity-60"></span>
    <span className="diamond-mark"></span>
    <div className="w-12 h-px bg-gradient-to-l from-transparent to-[#e4c590]"></div>
  </div>
);

const Contact = () => {
  const { t } = useI18n();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const onSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`CASA BALA — ${form.name}`);
    const body = encodeURIComponent(`${form.message}\n\n${form.name}\n${form.email}`);
    window.location.href = `mailto:${restaurantInfo.email}?subject=${subject}&body=${body}`;
  };

  const InfoRow = ({ icon: Icon, title, children }) => (
    <div className="flex items-start gap-4">
      <div className="w-12 h-12 border border-[#e4c590]/40 rounded-full flex items-center justify-center flex-shrink-0">
        <Icon size={20} className="text-[#e4c590]" />
      </div>
      <div>
        <h3 className="text-[#e4c590] uppercase tracking-widest text-xs mb-2">{title}</h3>
        {children}
      </div>
    </div>
  );

  return (
    <div className="bg-[#0a0a0a] pt-32 pb-24 min-h-screen">
      <div className="max-w-6xl mx-auto px-6">
        <Reveal direction="up">
          <div className="text-center mb-16">
            <p className="section-label">{t("contact.label")}</p>
            <h1 className="display text-5xl md:text-7xl text-[#f5f0e6] mt-3">{t("contact.title")}</h1>
            <DiamondDivider />
          </div>
        </Reveal>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <Reveal direction="left">
            <div className="space-y-8">
              <InfoRow icon={MapPin} title={t("contact.location")}>
                <p className="text-[#f5f0e6]">{t("contact.street")}</p>
                <p className="text-[#cfc7b8]">{t("contact.city")}</p>
              </InfoRow>
              <InfoRow icon={Phone} title={t("contact.phone")}>
                <a href={`tel:${restaurantInfo.phone}`} className="text-[#f5f0e6] hover:text-[#e4c590] transition-colors">{restaurantInfo.phone}</a>
              </InfoRow>
              <InfoRow icon={Mail} title={t("contact.email")}>
                <a href={`mailto:${restaurantInfo.email}`} className="text-[#f5f0e6] hover:text-[#e4c590] transition-colors">{restaurantInfo.email}</a>
              </InfoRow>
              <InfoRow icon={Clock} title={t("contact.hours")}>
                <p className="text-[#f5f0e6]">{t("common.work_days")}</p>
                <p className="text-[#cfc7b8]">12:00 - 24:00</p>
              </InfoRow>
            </div>
          </Reveal>
          <Reveal direction="right" delay={150}>
            <form onSubmit={onSubmit} className="bg-[#0f0f0f] border border-[#1f1f1f] p-8 lg:p-10 space-y-6">
              <h2 className="display text-3xl text-[#f5f0e6] mb-2">{t("contact.send_message")}</h2>
              <div>
                <label className="text-[#e4c590] uppercase tracking-widest text-xs block mb-2">{t("contact.name")}</label>
                <input name="name" value={form.name} onChange={onChange} required className="w-full bg-[#0a0a0a] border border-[#2a2a2a] focus:border-[#e4c590] outline-none px-4 py-3 text-[#f5f0e6] transition-colors" />
              </div>
              <div>
                <label className="text-[#e4c590] uppercase tracking-widest text-xs block mb-2">{t("contact.email_label")}</label>
                <input name="email" type="email" value={form.email} onChange={onChange} required className="w-full bg-[#0a0a0a] border border-[#2a2a2a] focus:border-[#e4c590] outline-none px-4 py-3 text-[#f5f0e6] transition-colors" />
              </div>
              <div>
                <label className="text-[#e4c590] uppercase tracking-widest text-xs block mb-2">{t("contact.message")}</label>
                <textarea name="message" value={form.message} onChange={onChange} required rows={5} className="w-full bg-[#0a0a0a] border border-[#2a2a2a] focus:border-[#e4c590] outline-none px-4 py-3 text-[#f5f0e6] transition-colors resize-none" />
              </div>
              <button type="submit" className="cb-btn cb-btn-gold inline-flex items-center gap-2">
                <span className="cb-btn-text cb-btn-text-1 inline-flex items-center gap-2"><Send size={14} /> {t("contact.send")}</span>
                <span className="cb-btn-text cb-btn-text-2 inline-flex items-center gap-2" aria-hidden="true"><Send size={14} /> {t("contact.send")}</span>
              </button>
            </form>
          </Reveal>
        </div>
      </div>
    </div>
  );
};

export default Contact;
